import { render, staticRenderFns } from "./gptFrack.vue?vue&type=template&id=543df132&scoped=true"
import script from "./gptFrack.vue?vue&type=script&lang=js"
export * from "./gptFrack.vue?vue&type=script&lang=js"
import style0 from "./gptFrack.vue?vue&type=style&index=0&id=543df132&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543df132",
  null
  
)

export default component.exports